function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5V5.83333M6.66668 2.5V5.83333M3.33334 9.16667H16.6667M3.33334 5.83333C3.33334 5.39131 3.50894 4.96738 3.8215 4.65482C4.13406 4.34226 4.55798 4.16667 5.00001 4.16667H15C15.442 4.16667 15.866 4.34226 16.1785 4.65482C16.4911 4.96738 16.6667 5.39131 16.6667 5.83333V15.8333C16.6667 16.2754 16.4911 16.6993 16.1785 17.0118C15.866 17.3244 15.442 17.5 15 17.5H5.00001C4.55798 17.5 4.13406 17.3244 3.8215 17.0118C3.50894 16.6993 3.33334 16.2754 3.33334 15.8333V5.83333ZM9.16668 13.3333C9.16668 13.5543 9.25447 13.7663 9.41075 13.9226C9.56703 14.0789 9.779 14.1667 10 14.1667C10.221 14.1667 10.433 14.0789 10.5893 13.9226C10.7455 13.7663 10.8333 13.5543 10.8333 13.3333C10.8333 13.1123 10.7455 12.9004 10.5893 12.7441C10.433 12.5878 10.221 12.5 10 12.5C9.779 12.5 9.56703 12.5878 9.41075 12.7441C9.25447 12.9004 9.16668 13.1123 9.16668 13.3333Z",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.2c34f815172dafb2b27194720668acbb.svg";
export { ForwardRef as ReactComponent };